import axios from "axios";

// Axios instance
const apiInstance = axios.create({
    baseURL:  `https://dkbsign.com/new_api_dkbsign/public`,
    timeout: 11000,
});

export default apiInstance